import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import ChangePasswordPage from "@/components/auth/ChangePasswordPage";

export default function ProtectedRoute({ children }) {
  const { user, bootstrapping, refreshUser } = useAuth();
  const location = useLocation();

  if (bootstrapping) {
    return (
      <div
        data-testid="protected-route-loading"
        className="flex min-h-screen items-center justify-center bg-slate-50"
      >
        <p className="text-slate-500">Loading...</p>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  // Invited users must rotate the temp password before reaching the dashboard.
  if (user.mustChangePassword) {
    return <ChangePasswordPage onCompleted={refreshUser} />;
  }
  return children;
}
